module.exports = __webpack_public_path__ + "static/media/pantaloneta_icon.e1c251a3.png";